import React from 'react'
import { Card } from 'reactstrap'

export default function PatientSearchCard() {
    return (
        <Card className='bg-transparent nex-search-card'>
            <h1 className='nex-text-xxl-2 text-center nex-search-card-title'>Make an appointment with a doctor</h1>
            <Card className='nex-search-fields'>
                <div className="nex-search-field-col ">
                    <div className="icon"><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        fill="none"
                        viewBox="0 0 24 25"
                    >
                        <path
                            fill="#001244"
                            fillOpacity="0.6"
                            d="M10.082 1.84C5.58 1.84 1.922 5.5 1.922 10c0 4.502 3.658 8.16 8.16 8.16a8.108 8.108 0 004.77-1.544l6.315 6.3 1.35-1.35-6.24-6.255A8.124 8.124 0 0018.242 10c0-4.502-3.658-8.16-8.16-8.16zm0 .96c3.982 0 7.2 3.218 7.2 7.2 0 3.983-3.218 7.2-7.2 7.2a7.192 7.192 0 01-7.2-7.2c0-3.982 3.217-7.2 7.2-7.2z"
                        ></path>
                    </svg></div>
                    <div className="form-group">
                        <input type="text" name="" className='form-control' placeholder='Symptoms, speciality, doctors...' />
                    </div>
                </div>
                <div className="nex-search-field-col location">
                    <div className="icon"><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="none"
                        viewBox="0 0 25 25"
                    >
                        <g clipPath="url(#clip0_3577_4272)">
                            <path
                                fill="#001244"
                                fillOpacity="0.6"
                                d="M12.203.88c-4.233 0-7.68 3.446-7.68 7.68 0 6.774 7.022 14.854 7.32 15.195a.476.476 0 00.36.165.494.494 0 00.36-.165c.299-.347 7.32-8.565 7.32-15.195 0-4.234-3.446-7.68-7.68-7.68zm0 5.28a2.88 2.88 0 11-.001 5.762 2.88 2.88 0 01.001-5.762z"
                            ></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_3577_4272">
                                <path
                                    fill="#fff"
                                    d="M0 0H24V24H0z"
                                    transform="translate(.203 .4)"
                                ></path>
                            </clipPath>
                        </defs>
                    </svg></div>
                    <div className="form-group">
                        <input type="text" name="" className='form-control' placeholder='Location' />
                    </div>
                </div>
                <div className="nex-search-field-col date">
                    <div className="icon"><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="none"
                        viewBox="0 0 25 25"
                    >
                        <g clipPath="url(#clip0_3577_4274)">
                            <g clipPath="url(#clip1_3577_4274)">
                                <g clipPath="url(#clip2_3577_4274)">
                                    <path
                                        fill="#001244"
                                        fillOpacity="0.6"
                                        d="M5.964.4a.967.967 0 00-.96.96v.96h-2.88c-.557 0-.96.403-.96.96v3.36h22.08V3.28c0-.557-.403-.96-.96-.96h-2.88v-.96a.967.967 0 00-.96-.96h-.96a.967.967 0 00-.96.96v.96h-8.64v-.96a.967.967 0 00-.96-.96h-.96zm0 .96h.96v2.88h-.96V1.36zm11.52 0h.96v2.88h-.96V1.36zM1.164 7.6v14.88c0 .557.403.96.96.96h20.16c.557 0 .96-.403.96-.96V7.6H1.164zm4.8 2.88h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm-10.08 3.36h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zM5.964 17.2h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4zm3.36 0h2.4v2.4h-2.4v-2.4z"
                                    ></path>
                                </g>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_3577_4274">
                                <path
                                    fill="#fff"
                                    d="M0 0H24V24H0z"
                                    transform="translate(.203 .4)"
                                ></path>
                            </clipPath>
                            <clipPath id="clip1_3577_4274">
                                <path
                                    fill="#fff"
                                    d="M0 0H24V24H0z"
                                    transform="translate(.203 .4)"
                                ></path>
                            </clipPath>
                            <clipPath id="clip2_3577_4274">
                                <path
                                    fill="#fff"
                                    d="M0 0H24V24H0z"
                                    transform="translate(.203 .4)"
                                ></path>
                            </clipPath>
                        </defs>
                    </svg></div>
                    <div className="form-group">
                        <input type="text" name="" className='form-control' placeholder='Feb 21, 2021' />
                    </div>
                </div>
                <div className="nex-search-field-col ins_plan">
                    <div className="icon"><svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="17"
      fill="none"
      viewBox="0 0 25 17"
    >
      <path
        fill="#001244"
        fillOpacity="0.6"
        d="M8.101 6.835V4.748H6.014v2.087H3.927v2.087h2.087v2.087h2.087V8.922h2.087V6.835H8.101zM24.275.575c.288 0 .522.233.522.521v14.609a.522.522 0 01-.522.522H1.32a.522.522 0 01-.522-.522V1.096c0-.288.233-.522.522-.522h22.956zM13.84 5.791h7.305a.522.522 0 000-1.044H13.84a.522.522 0 100 1.044zm0 3.13h7.305a.522.522 0 000-1.043H13.84a.522.522 0 100 1.043zm0 3.13h7.305a.522.522 0 000-1.043H13.84a.522.522 0 100 1.044z"
      ></path>
    </svg></div>
                    <div className="form-group">
                        <input type="text" name="" className='form-control' placeholder='Insurance plan' />
                    </div>
                </div>
                <div className="nex-search-field-col filter_select">
                    <div className="icon"><svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <rect
        width="24"
        height="24"
        x="0.398"
        y="0.4"
        fill="#001244"
        fillOpacity="0.6"
        rx="1.2"
      ></rect>
      <path
        fill="#fff"
        d="M6.995 5.2a.595.595 0 00-.534.33c-.41.077-1.266.306-1.266.956 0 .363.84 5.754 3.01 7.044-.001.024-.01.048-.01.073 0 .665.456 1.883 1.2 1.883.745 0 1.2-1.218 1.2-1.883 0-.025-.008-.049-.01-.073 2.171-1.29 3.01-6.681 3.01-7.044 0-.65-.855-.88-1.265-.955a.595.595 0 00-.535-.33c-.331 0-.6.262-.6.587 0 .325.269.588.6.588a.598.598 0 00.488-.248c.36.083.712.232.712.358 0 .526-.924 5.374-2.662 6.502-.195-.143-.437-.147-.553-.147-.059 0-.123-.002-.188 0a5.62 5.62 0 01-.394 0c-.064-.002-.128 0-.187 0-.116 0-.36.004-.553.147-1.738-1.127-2.663-5.976-2.663-6.502 0-.12.328-.27.713-.358.109.15.285.248.487.248.332 0 .6-.263.6-.588a.594.594 0 00-.6-.588zm10.5 6.76c-1.158 0-2.1.922-2.1 2.057 0 1.134.942 2.057 2.1 2.057 1.158 0 2.1-.923 2.1-2.057s-.942-2.057-2.1-2.057zm0 1.175c.496 0 .9.396.9.882a.893.893 0 01-.9.881.893.893 0 01-.9-.881c0-.486.405-.882.9-.882zm-7.762 2.893a1.312 1.312 0 01-.61.018c.128 1.44.813 3.554 4.472 3.554 2.965 0 3.842-1.807 4.097-2.948-.063.005-.131.01-.197.01-.14 0-.27-.018-.403-.037-.242.983-1.025 2.388-3.497 2.388-2.93 0-3.7-1.4-3.862-2.985z"
      ></path>
    </svg></div>
                    <div className="form-group">
                        <select className='form-control'>
                            <option>Appointments</option>
                            <option>Option 1</option>
                            <option>Option 2</option>
                        </select>
                    </div>
                </div>
                <div className="nex-search-field-col">
                    <div className="form-group">
                        <input type="text" value="Search" className='btn nex-btn-primary' />
                    </div>
                </div>
            </Card>
        </Card>
    )
}
